module.exports = __webpack_public_path__ + "live-share-guest-blue-09bc8518.png";